export const ssr = true;
export const csr = true;
export const prerender = false;